// extracted by mini-css-extract-plugin
export default {"mainmobile_container":"mainmobilepopup_mainmobile_container__OJs8v","mainmobile_title":"mainmobilepopup_mainmobile_title__J-UXW"};